/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubscriptionPlanPriceDto
 */
export interface SubscriptionPlanPriceDto {
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPlanPriceDto
     */
    monthlyPrice: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPlanPriceDto
     */
    trialDays: number;
}

/**
 * Check if a given object implements the SubscriptionPlanPriceDto interface.
 */
export function instanceOfSubscriptionPlanPriceDto(value: object): value is SubscriptionPlanPriceDto {
    if (!('monthlyPrice' in value) || value['monthlyPrice'] === undefined) return false;
    if (!('trialDays' in value) || value['trialDays'] === undefined) return false;
    return true;
}

export function SubscriptionPlanPriceDtoFromJSON(json: any): SubscriptionPlanPriceDto {
    return SubscriptionPlanPriceDtoFromJSONTyped(json, false);
}

export function SubscriptionPlanPriceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionPlanPriceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'monthlyPrice': json['monthlyPrice'],
        'trialDays': json['trialDays'],
    };
}

export function SubscriptionPlanPriceDtoToJSON(json: any): SubscriptionPlanPriceDto {
    return SubscriptionPlanPriceDtoToJSONTyped(json, false);
}

export function SubscriptionPlanPriceDtoToJSONTyped(value?: SubscriptionPlanPriceDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'monthlyPrice': value['monthlyPrice'],
        'trialDays': value['trialDays'],
    };
}

